import React from 'react'

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import Products from './products'

import * as styles from './text.module.scss'


const Text = ({ title, content, products, className }) => {

    if (title || content) {
        return (
            <SlideinWrap className={className}>
                {title && (
                    <SlideinItem delay={0} tagName="h2" className={styles.title}>{title}</SlideinItem>
                )}
                {content && (
                    <SlideinItem delay={300} className={styles.content} dangerouslySetInnerHTML={{ __html: content }}></SlideinItem>
                )}
                {products && (
                    <div className={styles.products}>
                        <Products products={products} />
                    </div>
                )}
            </SlideinWrap>
        )
    } else {
        return null
    }
}

export default Text